import React from 'react';
import { useScreenInit } from '../useScreenInit';
import { Logo } from '../components/ui/Logo';
import { FicheTPPanel, CertifTPPanel, FicheBTSPanel, CertifBTSPanel, ModalitesAccessPanel } from '../components/CataloguePanels';
export function Catalogue() {
  useScreenInit();
  return <div className="flex flex-col w-full bg-muted min-h-screen pb-24" data-id="element-844">
      <div className="container max-w-6xl mx-auto py-12 space-y-16" data-id="element-845">
        {/* Page 1: Cover */}
        <div className="bg-white shadow-2xl overflow-hidden flex flex-col" data-id="element-846">
          <div className="h-28 flex items-center justify-center bg-white shrink-0" data-id="element-847">
            <div className="scale-[1.7] origin-center" data-id="element-848">
              <Logo data-id="element-849" />
            </div>
          </div>
          <div className="flex-1 flex" data-id="element-850">
            <div className="w-[55%] bg-primary-dark p-12 flex flex-col justify-center text-white relative" data-id="element-851">
              <div className="inline-block bg-brand-orange text-white font-heading font-bold px-4 py-2 text-sm tracking-wider mb-8 w-fit" data-id="element-852">
                CATALOGUE DE FORMATIONS EN ALTERNANCE
              </div>
              <h1 className="text-5xl md:text-6xl font-heading font-extrabold leading-tight mb-8" data-id="element-853">
                CATALOGUE
                <br data-id="element-854" />
                FORMATIONS
                <br data-id="element-855" />
                2026
              </h1>
              <p className="text-xl font-medium leading-relaxed max-w-md" data-id="element-856">
                Deux parcours professionnalisants en alternance, avec une
                information publique détaillée, vérifiable et accessible.
              </p>
            </div>
            <div className="w-[45%] bg-lavande p-12 flex items-center justify-center" data-id="element-857">
              <div className="bg-white p-10 w-full shadow-lg" data-id="element-858">
                <h2 className="text-2xl font-heading font-extrabold text-primary-dark mb-8" data-id="element-859">
                  SESSIONS OUVERTES
                </h2>
                <div className="space-y-6 mb-8" data-id="element-860">
                  <div className="border-l-4 border-brand-orange pl-4" data-id="element-861">
                    <h3 className="text-xl font-bold text-primary-dark" data-id="element-862">
                      BTS NDRC
                    </h3>
                    <p className="text-primary-dark font-medium" data-id="element-863">
                      Session 2026–2028
                    </p>
                  </div>
                  <div className="border-l-4 border-brand-orange pl-4" data-id="element-864">
                    <h3 className="text-xl font-bold text-primary-dark" data-id="element-865">
                      TP Conseiller de Vente
                    </h3>
                    <p className="text-primary-dark font-medium" data-id="element-866">
                      Session 2026–2027
                    </p>
                  </div>
                </div>
                <p className="text-sm text-primary-dark font-medium leading-relaxed" data-id="element-867">
                  Rentrée prévisionnelle : 25 septembre 2026, sous réserve de
                  places disponibles et de signature du contrat d'apprentissage.
                </p>
              </div>
            </div>
          </div>
          <div className="bg-primary-dark border-t border-white/10 p-6 text-center text-white shrink-0" data-id="element-868">
            <p className="font-medium" data-id="element-869">
              Zillenium Alternance • 25 rue Gabriel Cortel – 89300 Joigny
              <br data-id="element-870" />
              09 83 49 01 81 • contact@zilleniumalternance.fr
            </p>
            <p className="text-xs text-white/60 mt-2" data-id="element-871">
              Version 2, septembre 2025
            </p>
          </div>
        </div>

        {/* Page 2: Repères */}
        <div className="bg-lavande shadow-2xl overflow-hidden flex flex-col" data-id="element-872">
          <div className="bg-primary-dark p-8 flex justify-between items-center shrink-0" data-id="element-873">
            <div data-id="element-874">
              <p className="text-brand-orange font-bold text-sm tracking-wider mb-1" data-id="element-875">
                INFORMATION PUBLIQUE AVANT INSCRIPTION
              </p>
              <h2 className="text-3xl font-heading font-extrabold text-white" data-id="element-876">
                REPÈRES CANDIDATS ET ENTREPRISES
              </h2>
            </div>
            <div className="bg-brand-orange text-white font-bold px-6 py-2" data-id="element-877">
              Catalogue 2026
            </div>
          </div>
          <div className="flex-1 flex p-8 gap-8" data-id="element-878">
            <div className="w-1/2 flex flex-col" data-id="element-879">
              <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-4" data-id="element-880">
                OFFRE PUBLIÉE
              </h3>
              <p className="text-primary-dark font-bold mb-6" data-id="element-881">
                Zillenium Alternance présente uniquement les formations ouvertes
                sur les sessions confirmées.
              </p>
              <div className="flex-1 flex flex-col gap-1 text-sm" data-id="element-882">
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-883">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-884">
                    FORMATIONS
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-885">
                    TP Conseiller de Vente 2026–2027 ; BTS NDRC 2026–2028.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-886">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-887">
                    PUBLIC
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-888">
                    Candidats en alternance, entreprises d'accueil et
                    prescripteurs.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-889">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-890">ACCÈS</div>
                  <div className="w-2/3 text-primary-dark" data-id="element-891">
                    Candidature, entretien, positionnement, validation du projet
                    et contrat.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-892">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-893">
                    TARIF APPRENTI
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-894">
                    0 € pour l'apprenti sous contrat, financement selon OPCO.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-895">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-896">
                    RYTHME
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-897">
                    Alternance école / entreprise, modalités précisées dans
                    chaque fiche.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-898">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-899">
                    MOYENS
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-900">
                    Cours, ateliers, cas pratiques, mises en situation et suivi
                    individualisé.
                  </div>
                </div>
              </div>
              <div className="bg-primary-dark text-white p-4 mt-4 text-sm font-medium" data-id="element-901">
                <span className="text-brand-orange font-bold" data-id="element-902">
                  Avant l'entrée en formation :
                </span>{' '}
                le candidat reçoit le programme, les modalités d'accès, les
                prérequis, les conditions tarifaires, les contacts utiles et les
                informations relatives à la certification visée.
              </div>
            </div>
            <div className="w-1/2 flex flex-col" data-id="element-903">
              <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-4" data-id="element-904">
                CERTIFICATION ET RÉSULTATS
              </h3>
              <p className="text-primary-dark font-bold mb-6" data-id="element-905">
                Chaque fiche mentionne la certification professionnelle visée,
                ses blocs et le lien officiel vérifiable.
              </p>
              <div className="flex-1 flex flex-col gap-1 text-sm" data-id="element-906">
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-907">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-908">
                    TP VENTE
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-909">
                    RNCP37098, niveau 4, Ministère chargé de l'emploi, échéance
                    25/01/2028.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-910">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-911">
                    BTS NDRC
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-912">
                    RNCP38368, niveau 5, Ministère chargé de l'enseignement
                    supérieur, échéance 31/12/2028.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-913">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-914">
                    RÉSULTATS TP
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-915">
                    Session 2024–2025 : 100 %. Session 2026–2027 : examen à
                    venir.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-916">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-917">
                    RÉSULTATS BTS
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-918">
                    Sessions 2025–2027 et 2026–2028 : examens prévus en 2027 et
                    2028.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-919">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-920">
                    ACCESSIBILITÉ
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-921">
                    Étude individualisée des besoins et adaptation possible du
                    parcours.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-922">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-923">
                    MISE À JOUR
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-924">
                    Les indicateurs sont actualisés après les sessions
                    réellement présentées.
                  </div>
                </div>
              </div>
              <div className="bg-primary-dark text-white p-4 mt-4 text-sm font-medium" data-id="element-925">
                <span className="text-brand-orange font-bold" data-id="element-926">Contacts :</span>{' '}
                09 83 49 01 81 • contact@zilleniumalternance.fr • Référent
                handicap : samir@zilleniumalternance.fr.
              </div>
            </div>
          </div>
          <div className="bg-lavande/50 p-6 text-center text-primary-dark shrink-0 font-bold" data-id="element-927">
            <p data-id="element-928">
              Zillenium Alternance • 25 rue Gabriel Cortel, 89300 Joigny •
              Catalogue public des formations en alternance
            </p>
            <p className="text-xs font-normal text-primary-dark/60 mt-2" data-id="element-929">
              Version 2, septembre 2025
            </p>
          </div>
        </div>

        {/* Page 3: Fiche TP */}
        <FicheTPPanel data-id="element-930" />

        {/* Page 4: Certif TP */}
        <CertifTPPanel data-id="element-931" />

        {/* Page 5: Fiche BTS */}
        <FicheBTSPanel data-id="element-932" />

        {/* Page 6: Certification BTS NDRC */}
        <CertifBTSPanel data-id="element-933" />

        {/* Page 7: Modalités d'accès */}
        <ModalitesAccessPanel data-id="element-934" />
      </div>
    </div>;
}